import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CapacityOverviewComponent } from './capacity-overview.component';

const routes: Routes = [
  {
    path: '',
    component: CapacityOverviewComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CapacityOverviewRoutingModule { }
